exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".on-1 {\n    fill: #72cac2;\n  }\n\n.on-2 {\n    fill: #fff;\n  }\n", ""]);
